export default __webpack_public_path__ + "static/media/support-notes-main-cointelegraph.97d83bd5.png";